import {
  SAVE_TREATMENT_REPORT_FAILURE,
  SAVE_TREATMENT_REPORT_SUCCESS,
  SAVE_TREATMENT_REPORT_REQUEST,
  FETCH_TREATMENT_REPORTS_REQUEST,
  FETCH_TREATMENT_REPORTS_SUCCESS,
  FETCH_TREATMENT_REPORTS_FAILURE,
  FETCH_TREATMENT_REPORT_REQUEST,
  FETCH_TREATMENT_REPORT_SUCCESS,
  FETCH_TREATMENT_REPORT_FAILURE,
  DELETE_TREATMENT_REPORT_REQUEST,
  DELETE_TREATMENT_REPORT_SUCCESS,
  DELETE_TREATMENT_REPORT_FAILURE,
  FETCH_TREATMENT_COMPLETE_REQUEST,
  FETCH_TREATMENT_COMPLETE_SUCCESS,
  FETCH_TREATMENT_COMPLETE_FAILURE,
} from './types';

const INITIAL_STATE = {
  treatmentReports: [],
  treatmentReport: null,
  treatmentReportComplete: null,
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_TREATMENT_REPORTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_TREATMENT_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        treatmentReports: action.payload,
      };

    case FETCH_TREATMENT_REPORTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        treatmentReports: [],
      };
    case FETCH_TREATMENT_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_TREATMENT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        treatmentReport: action.payload,
      };

    case FETCH_TREATMENT_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        treatmentReport: null,
      };
    case SAVE_TREATMENT_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_TREATMENT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_TREATMENT_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case DELETE_TREATMENT_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_TREATMENT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_TREATMENT_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case FETCH_TREATMENT_COMPLETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_TREATMENT_COMPLETE_SUCCESS:
      return {
        ...state,
        loading: false,
        treatmentReportComplete: action.payload,
      };

    case FETCH_TREATMENT_COMPLETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        treatmentReportComplete: null,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
